import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BaseConfigModal from "@plannel/components/modal/BaseConfigModal";
import MeasureConfigList from "@plannel/components/modal/MeasureConfigList";

/*
 * 공용 차트 설정 모달 — 시리즈(measure)별 활성 여부(activeFlg)와 차트 타입(BAR/LINE)을 설정.
 * 저장 위치는 호출측이 결정(onSave) — 예: z_p13n.
 *
 * 셸 = BaseConfigModal, 본문 = MeasureConfigList (둘 다 표준).
 *
 * props
 *   open, onClose        : 모달 열림/닫기
 *   config               : { [key]: { chartType: "BAR"|"LINE", activeFlg?: boolean } }
 *   onSave(draft)        : 저장 콜백 (편집본 config 전달)
 *   measures             : [{ key, label, hasActive }]  — 이 모달에서 다룰 측정치
 *   chartTypes           : 선택 가능한 차트 타입(기본 ["BAR","LINE"]). AREA 등 추가 가능.
 */
const ChartConfigModal = ({ open, onClose, config, onSave, measures = [], chartTypes = ["BAR", "LINE"] }) => {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(config);
  useEffect(() => { if (open) setDraft(config); }, [open, config]);

  const anyActive = measures.some((r) => r.hasActive);

  return (
    // 활성 체크박스 열이 있으면 한 단계 넓게(md) — 없으면 sm
    <BaseConfigModal
      open={open}
      onClose={onClose}
      title={t("chartConfig")}
      onSave={() => onSave(draft)}
      size={anyActive ? "md" : "sm"}
    >
      <MeasureConfigList
        open={open}
        measures={measures}
        draft={draft}
        setDraft={setDraft}
        chartTypes={chartTypes}
      />
    </BaseConfigModal>
  );
};

export default ChartConfigModal;
